import { render, staticRenderFns } from "./recordPlate.vue?vue&type=template&id=828c3052&scoped=true&"
import script from "./recordPlate.vue?vue&type=script&lang=js&"
export * from "./recordPlate.vue?vue&type=script&lang=js&"
import style0 from "./recordPlate.vue?vue&type=style&index=0&id=828c3052&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828c3052",
  null
  
)

component.options.__file = "recordPlate.vue"
export default component.exports